<ng-container *transloco="let t; read: 'accounts'">
<div class="flex justify-between border-b mb-6">
  <h1 class="text-[25px] font-bold">{{ t('userRoles.deleteTitle') }}</h1>
  <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
</div>

<div mat-dialog-content>
  <p [innerHTML]="deleteMessage"></p>
</div>

<div mat-dialog-actions class="flex justify-end">
  <drdp-btn class="mr-2" color="cancel" mat-button mat-dialog-close>{{ t('common.cancel') }}</drdp-btn>
  <drdp-btn color="red" mat-button [mat-dialog-close]="onSubmit()" cdkFocusInitial>{{ t('common.delete') }}</drdp-btn>

</div>
</ng-container>